window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
//上にスクロールでメニュー表示 (jQuery)

var startPos = 0, currentPos = 0;
var globalnavElm = $('.global-nav');
var globalnavElmh = globalnavElm.innerHeight();
var mainHeaderElm = $('#mainHeader');
var mainHeaderElmh = mainHeaderElm.innerHeight();
var subHeaderElmh = $('#subHeader').innerHeight();

$(window).scroll(function() {
    var currentPos = $(this).scrollTop();
    var doch = $(document).innerHeight();
    var winh = $(window).innerHeight(); 
    var pageBottom = doch - winh;
    
    if (currentPos >= pageBottom) { //最下部
        globalnavElm.css('top', 0 + 'px');
        globalnavElm.css('transition','.2s');
        mainHeaderElm.css('border-bottom', '1px solid #eee');
    } else if (currentPos <= 0){ //最上部
        globalnavElm.css('top', 0 + 'px');
        globalnavElm.css('transition','.5s');
        mainHeaderElm.css('border-bottom', '1px solid #eee');
    } else if (currentPos >= startPos && currentPos <= mainHeaderElmh){  //最初からスクロールかつ、その時表示のヘッダの半分までの場合
        globalnavElm.css('top', (0 - currentPos) + 'px');
        globalnavElm.css('transition','0s');
        mainHeaderElm.css('border-bottom', '1px solid #eee');
    } else if (currentPos >= startPos && currentPos >= mainHeaderElmh){  //最初からスクロールかつ、その時表示のヘッダの半分よりもスクロールした場合
        globalnavElm.css('top', (0 - mainHeaderElmh) + 'px');
        globalnavElm.css('transition','.2s');
        mainHeaderElm.css('border-bottom', 0 + 'px');
    } else if (currentPos >= startPos){  //最初よりもスクロールした場合(戻る時用)
        globalnavElm.css('top', 0 + 'px');
        globalnavElm.css('transition','.5s');
        mainHeaderElm.css('border-bottom', '1px solid #eee');
    } else { // 上に戻るスクロール
        globalnavElm.css('top', 0 + 'px');
        globalnavElm.css('transition','.5s');
        mainHeaderElm.css('border-bottom', '1px solid #eee');
    }
    startPos = currentPos;
});

//subHeader有無によるマージン分岐 (ガタつき防止のためにcssで最大値を初期指定しておく)
$(window).ready(function() {
    if($('#subHeader').length){
        $('.main-content').css('margin-top', globalnavElmh + 'px');
    } else {
        $('.global-nav').css('height', mainHeaderElmh + 'px');
        $('.main-content').css('margin-top', mainHeaderElmh + 'px');
        globalnavElm.css('transition','0s');
    }
});


//sp menu
$(function(){
    var burger = $('.burger-container');
    var main = $('main');
    var modal = $('#spModalMenu');

    burger.click(function() { //クリックでメニュー開閉
        modal.toggleClass('menu-opened');
        burger.toggleClass('menu-opened');
        main.toggleClass('menu-opened');
    });
    $(window).scroll(function() {　//スクロール時にメニューが開いていたら閉じる
        modal.removeClass('menu-opened');
        burger.removeClass('menu-opened');
        main.removeClass('menu-opened');
    });
    $(window).resize(function() { //ブラウザのリサイズでメニューが開いていたら閉じる
        modal.removeClass('menu-opened');
        burger.removeClass('menu-opened');
        main.removeClass('menu-opened');
    });
});








    
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

$(function(){
    if($('.typetester-field').length) {
    
    //全てのコントローラーに個別処理
    $(".tester").each(function(i) {
      $(this).attr('id','tester' + (i+1));//ボックスにidを連番で付与
      $(this).find('.typedtext').attr('id','textinput' + (i+1));//テキストボックスにidを連番で付与
      $(this).find('.textselector').attr('id','textselector' + (i+1));//textselectorにidを連番で付与
    });
    
    //各コントローラーの設定
    $(".tester").each(function() {

        //全テキストボックスのid取得
        var inputText_id = '#'+$(this).closest('.tester').find('.typedtext').attr('id');
        //全テキストボックスのデフォルトテキストを変数に格納
        var defaultText = $(inputText_id).text();
        
        //--テキスト変更
        $(this).find('.textselector').mousedown(function(){

            //テキストを変数に格納
            var txt0 = defaultText;
            var txt1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890";
            var txt2 = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.";
    
            //セレクトボックスが切り替わったら発動
            $(this).change(function(){
                //value取得
                var val = $(this).val();
                //valの値に応じて文字列を代入する
                if (val == '0'){
                    $(this).closest('.tester').find('.typedtext').text(txt0);
                }
                else if (val == '1'){
                    $(this).closest('.tester').find('.typedtext').text(txt1);
                }else if (val == '2'){
                    $(this).closest('.tester').find('.typedtext').text(txt2);
                }else{
            }
        });
    });
   
    //--スタイル変更
    $(this).find('.styleselector').mousedown(function(){

        $(this).change(function(){
                //value取得
                let val = $(this).val();
                //valの値に応じてスタイルを変更する
                //For Astro
                if (val == 'style-astro-1'){
                    var fontSetting = {
                        'font-family':'Astro-1',
                        'font-style':'normal'    
                    }
                }else if (val == 'style-astro-2'){
                    var fontSetting = {
                        'font-family':'Astro-5',
                        'font-style':'normal'    
                    }
                }else if (val == 'style-astro-3'){
                    var fontSetting = {
                        'font-family':'Astro-10',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-4'){
                    var fontSetting = {
                        'font-family':'Astro-15',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-5'){
                    var fontSetting = {
                        'font-family':'Astro-20',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-6'){
                    var fontSetting = {
                        'font-family':'Astro-25',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-7'){
                    var fontSetting = {
                        'font-family':'Astro-30',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-8'){
                    var fontSetting = {
                        'font-family':'Astro-35',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-9'){
                    var fontSetting = {
                        'font-family':'Astro-40',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-10'){
                    var fontSetting = {
                        'font-family':'Astro-45',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-11'){
                    var fontSetting = {
                        'font-family':'Astro-50',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-12'){
                    var fontSetting = {
                        'font-family':'Astro-55',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-13'){
                    var fontSetting = {
                        'font-family':'Astro-60',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-14'){
                    var fontSetting = {
                        'font-family':'Astro-65',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-15'){
                    var fontSetting = {
                        'font-family':'Astro-70',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-16'){
                    var fontSetting = {
                        'font-family':'Astro-75',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-17'){
                    var fontSetting = {
                        'font-family':'Astro-80',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-18'){
                    var fontSetting = {
                        'font-family':'Astro-85',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-19'){
                    var fontSetting = {
                        'font-family':'Astro-90',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-20'){
                    var fontSetting = {
                        'font-family':'Astro-95',
                        'font-style':'normal'
                        }
                }else if (val == 'style-astro-21'){
                    var fontSetting = {
                        'font-family':'Astro-1s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-22'){
                    var fontSetting = {
                        'font-family':'Astro-5s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-23'){
                    var fontSetting = {
                        'font-family':'Astro-10s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-24'){
                    var fontSetting = {
                        'font-family':'Astro-15s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-25'){
                    var fontSetting = {
                        'font-family':'Astro-20s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-26'){
                    var fontSetting = {
                        'font-family':'Astro-25s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-27'){
                    var fontSetting = {
                        'font-family':'Astro-30s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-28'){
                    var fontSetting = {
                        'font-family':'Astro-35s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-29'){
                    var fontSetting = {
                        'font-family':'Astro-40s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-30'){
                    var fontSetting = {
                        'font-family':'Astro-45s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-31'){
                    var fontSetting = {
                        'font-family':'Astro-50s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-32'){
                    var fontSetting = {
                        'font-family':'Astro-55s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-33'){
                    var fontSetting = {
                        'font-family':'Astro-60s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-34'){
                    var fontSetting = {
                        'font-family':'Astro-65s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-35'){
                    var fontSetting = {
                        'font-family':'Astro-70s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-36'){
                    var fontSetting = {
                        'font-family':'Astro-75s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-37'){
                    var fontSetting = {
                        'font-family':'Astro-80s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-38'){
                    var fontSetting = {
                        'font-family':'Astro-85s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-39'){
                    var fontSetting = {
                        'font-family':'Astro-90s',
                        'font-style':'italic'
                        }
                }else if (val == 'style-astro-40'){
                    var fontSetting = {
                        'font-family':'Astro-95s',
                        'font-style':'italic'
                        }
                //for Norm No6
                }else if (val == 'style-norm-no6-1'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'200',
                        'font-style':'normal'
                        }
                }else if (val == 'style-norm-no6-2'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'200',
                        'font-style':'italic'
                        }
                }else if (val == 'style-norm-no6-3'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'300',
                        'font-style':'normal'
                        }
                }else if (val == 'style-norm-no6-4'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'300',
                        'font-style':'italic'
                        }
                }else if (val == 'style-norm-no6-5'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'400',
                        'font-style':'normal'
                        }
                }else if (val == 'style-norm-no6-6'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'400',
                        'font-style':'italic'
                        }
                }else if (val == 'style-norm-no6-7'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'450',
                        'font-style':'normal'
                        }
                }else if (val == 'style-norm-no6-8'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'450',
                        'font-style':'italic'
                        }
                }else if (val == 'style-norm-no6-9'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'500',
                        'font-style':'normal'
                        }
                }else if (val == 'style-norm-no6-10'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'500',
                        'font-style':'italic'
                        }
                }else if (val == 'style-norm-no6-11'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'600',
                        'font-style':'normal'
                        }
                }else if (val == 'style-norm-no6-12'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'600',
                        'font-style':'italic'
                        }
                }else if (val == 'style-norm-no6-13'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'700',
                        'font-style':'normal'
                        }
                }else if (val == 'style-norm-no6-14'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'700',
                        'font-style':'italic'
                        }
                }else if (val == 'style-norm-no6-15'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'800',
                        'font-style':'normal'
                        }
                }else if (val == 'style-norm-no6-16'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'800',
                        'font-style':'italic'
                        }
                }else if (val == 'style-norm-no6-17'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'900',
                        'font-style':'normal'
                        }
                }else if (val == 'style-norm-no6-18'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'900',
                        'font-style':'italic'
                        }
                }else if (val == 'style-norm-no6-19'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'1000',
                        'font-style':'normal'
                        }
                }else if (val == 'style-norm-no6-20'){
                    var fontSetting = {
                        'font-family':'Norm No6',
                        'font-weight':'1000',
                        'font-style':'italic'
                        }
                //for Norm No11
              }else if (val == 'style-norm-no11-1'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'200',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no11-2'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'200',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no11-3'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'300',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no11-4'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'300',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no11-5'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'400',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no11-6'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'400',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no11-7'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'450',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no11-8'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'450',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no11-9'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'500',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no11-10'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'500',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no11-11'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'600',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no11-12'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'600',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no11-13'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'700',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no11-14'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'700',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no11-15'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'800',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no11-16'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'800',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no11-17'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'900',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no11-18'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'900',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no11-19'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'1000',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no11-20'){
                var fontSetting = {
                    'font-family':'Norm No11',
                    'font-weight':'1000',
                    'font-style':'italic'
                    }
                //for Norm No15
              }else if (val == 'style-norm-no15-1'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'200',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no15-2'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'200',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no15-3'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'300',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no15-4'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'300',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no15-5'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'400',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no15-6'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'400',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no15-7'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'450',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no15-8'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'450',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no15-9'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'500',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no15-10'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'500',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no15-11'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'600',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no15-12'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'600',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no15-13'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'700',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no15-14'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'700',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no15-15'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'800',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no15-16'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'800',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no15-17'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'900',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no15-18'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'900',
                    'font-style':'italic'
                    }
            }else if (val == 'style-norm-no15-19'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'1000',
                    'font-style':'normal'
                    }
            }else if (val == 'style-norm-no15-20'){
                var fontSetting = {
                    'font-family':'Norm No15',
                    'font-weight':'1000',
                    'font-style':'italic'
                    }
                } else {
                }
            $(this).closest('.tester').find('.typedtext').css(fontSetting);
            });
        });
    });
   
    //--text-align変更
    $(function(){
        $('button.left').click(function(){
            const textboxId = $(this).closest('.tester').find('.typedtext').attr('id');
            $('#'+textboxId).css('text-align','left');
        });
        $('button.center').click(function(){
            const textboxId = $(this).closest('.tester').find('.typedtext').attr('id');
            $('#'+textboxId).css('text-align','center');
        });
        $('button.right').click(function(){
            const textboxId = $(this).closest('.tester').find('.typedtext').attr('id');
            $('#'+textboxId).css('text-align','right');
        });
    });


    //--サイズ変更 スライダー
        //スライダーが動いたらフォントサイズを変更 
        $('.sizechanger').on('input change',function(){
            let val = $(this).val();
            let inputSize_id = '#size'+$(this).attr('data-input');
            let inputText_id = '#text'+$(this).attr('data-input');
            let fontSize = (val)+'px';

            $(inputSize_id).val(val);
            $(inputText_id).css('font-size',fontSize);
        });

        //--行間line-height変更 スライダー
        //スライダーが動いたらline-heightを変更 
        $('.linechanger').on('input change',function(){
            let val = $(this).val();
            let inputLineHeight_id = '#line'+$(this).attr('data-input');
            let inputText_id = '#text'+$(this).attr('data-input');
            let LineHeight = (val);

            $(inputLineHeight_id).val(val);
            $(inputText_id).css('line-height',LineHeight);
        });
}//endif
});//close
    
//this file is related to cookieconsent.min.js and cookieconsent.min.scss

window.addEventListener("load", function(){
    window.cookieconsent.initialise({
      "palette": {
        "popup": {
          "background": "#eee",
          "text": "#353535"
        },
        "button": {
          "background": "#0a0a0a"
        }
      },
      "position": "bottom-right",
      "content": {
        "message": "This website uses cookies to improve user experience. By using our website you consent to all cookies in accordance with our Cookie Policy.",
        "dismiss": "I agree.",
        "href": "/pages/privacy"
      }
    })});    
/* for font page */

// slider
var swiper = new Swiper ('.swiper-container', {
  navigation: {
      nextEl: '.next',
      prevEl: '.prev',
  },
	on: { // スライドで動画操作
		slideChange: function () {
			realIndex = this.realIndex; // 現在のスライドを取得
			slideLength = this.slides.length;//スライドの枚数の取得
			slideClass = $('.swiper-slide-' + realIndex);
			video = slideClass.find('video');
			$('.swiper-wrapper').find('video').each(function( index, value ) { // 全て停止
				if (realIndex == 0){
					$(this).get(0).play();
				} else if (realIndex == slideLength-3) {
					$(this).get(0).play();
				} else {
					$(this).get(0).pause();
				}
			});
			if (video.length) {
				video.get(0).play();
			} 
		},
	},
  autoplay: {
      delay: 12000,
  },
  effect: 'fade',
  loop: true,
  speed: 300,
});

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

$('#orderItemList').ready(function(){
    $(this).find('.item-number').each(function(i) {
        $(this).html(i+1);//item番号を連番で付与
    });
});
//--collection page
if($('#select-license').ready()){

	$(function() {// to change color with selected url
		var url = window.location.pathname;
		$('a[href="'+url+'"]').addClass('btn-link-selected');
		});

	$(function() {// to change text in quick chart
		var type = $('.btn-link-selected').find('span').text();

		var qcDesktop = 'Desktop license is a basic license that you can install and use	fonts on your PC. The fonts are provided in OpenType format. You can install the font on the number of computers you selected at the time of purchase, within a single company. You can use the fonts for creating print works using desktop applications, creating static designs such as logos, creating design comps of applications and web design comps, creating slides for presentations, etc. Please confirm the <a href ="/pages/eula/#desktop" target="_blank">EULA</a> before purchasing.',
				qcWeb = 'Web license allows you to use the fonts on licensed websites. Fonts are provided in Woff and Woff2 format and can be used in self-hosting format using @font-face. For creating design comp with Adobe CC, Sketch, etc., please purchase Desktop license. Please confirm the <a href ="/pages/eula/#web" target="_blank">EULA</a> before purchasing.',
				qcApp = 'App license allows you to embed the fonts on licensed mobile Apps. Fonts are provided in OpenType format. For creating design comp with Adobe CC, Sketch, etc., please purchase Desktop license. Please confirm the <a href ="/pages/eula/#app" target="_blank">EULA</a> before purchasing.',
				qcEpub = 'This ePub license allows you to embed the fonts on licensed Ebooks. Fonts are provided in OpenType format. For creating design comp with Adobe CC, Sketch, etc., please purchase Desktop license. Please confirm the <a href ="/pages/eula/#epub" target="_blank">EULA</a> before purchasing.';
	
		if(type == 'Desktop'){
			$('#qcText').find('.qc-title').html('What is a Desktop license?');
			$('#qcText').find('.qc-text').html(qcDesktop);
		}else if(type == 'Web'){
			$('#qcText').find('.qc-title').html('What is a Web license?');
			$('#qcText').find('.qc-text').html(qcWeb);
		}else if(type == 'App'){
			$('#qcText').find('.qc-title').html('What is a App license?');
			$('#qcText').find('.qc-text').html(qcApp);
		}else if(type == 'ePub'){
			$('#qcText').find('.qc-title').html('What is a ePub license?');
			$('#qcText').find('.qc-text').html(qcEpub);
		}	

	});
	// message if customers choose other license
	$('#btn-link-others').on('click',function(){
		//change button border color
		$('.btn-link').removeClass('btn-link-selected');
		$('#btn-link-others').addClass('btn-link-selected');
		//hide quick chart
		$('.quick-chart').addClass('hide');
		//show and hide collection list
		$('#collection-license-usual').addClass('hide');
		$('#collection-license-others').removeClass('hide');
	});

}



//--about, about-jp - add hisoty text
$('#moreBtn').click(function(){
$(this).parent('.more-button').addClass('hide')
$('#historyAdd').removeClass('hide')
});


//--blog.news - infinite pagenagte -- ajaxinate-min.min.js
document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      method: 'scroll'
    });
  });


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

//-- cart page license agreement check form
  $(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  });

// 画面にあるときだけ指定の要素を表示する, .saがついた要素のみ, data-sa_delay="***"で遅延
var scrollAnimationClass = 'sa';
var scrollAnimationShowClass = 'show';
var scrollAnimationElm = document.querySelectorAll('.' + scrollAnimationClass);
var scrollAnimationFunc = function() {
    for(var i = 0; i < scrollAnimationElm.length; i++) {
        var elm = scrollAnimationElm[i];
        if (window.innerHeight > scrollAnimationElm[i].getBoundingClientRect().top) {
            setTimeout(function(index) {
                scrollAnimationElm[index].classList.add('show');
            }.bind(null, i),i*60);
        }
    }
}
window.addEventListener('load', scrollAnimationFunc);
window.addEventListener('scroll', scrollAnimationFunc);

//ハッシュタグでページ内遷移時のheader分のズレ対策
$('a[href^="#"]').click(function() {
  var speed = 500;
  var val = $(window).scrollTop();
  var href= $(this).attr("href");
  var target = $(href == "#" || href == "" ? 'html' : href);
  var position = target.offset().top - 120;
  $('body,html').stop().animate({scrollTop:position}, speed, 'swing');
  return false;
  });

//blog サイドナビゲーション固定 pretty scroll
if (window.matchMedia('screen and (min-width:959px)').matches && ($('[data-ps]').length > 0) ) {
window.addEventListener('DOMContentLoaded', function(){
  new PrettyScroll('.pretty', { // スクロール固定したい要素を指定
    container: '.article-list', // スクロールする要素領域を指定
    offsetTop: 140, //スクロール固定する際のwindow上からの距離を指定
    offsetBottom: 20, // スクロール固定する際のwindow下からの距離を指定
    breakpoint: 768, // スクロール固定を有効にするbreakpointを設定
    condition: function() {return true;} // スクロール固定を有効にする条件を指定。この条件判定はスクロールの度に発生。デフォルトでは常にtrueを返す。
  });
});
};

//password
$('#loginBtn').click(function(){
  $('main').css({'display':'block','min-height':'100px'});
});